import React from 'react';

export const UsersPage: React.FC = () => {
  return <div>Gestión de Usuarios</div>;
};